import { render, staticRenderFns } from "./AppBarInfos.vue?vue&type=template&id=20d9fd30&scoped=true&"
import script from "./AppBarInfos.vue?vue&type=script&lang=js&"
export * from "./AppBarInfos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d9fd30",
  null
  
)

export default component.exports